// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import your translation files
import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    fr: {
      translation: fr,
    },
    es: {
      translation: es,
    },
  },
  lng: "es", // default language
  fallbackLng: "es", // fallback language if the selected language is not available
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export default i18n;
